import { createFileRoute } from '@tanstack/react-router';
import { SettingsPage } from '../../features/tenancy';

export const Route = createFileRoute('/portal/company')({ component: SettingsPage });
